import { render, staticRenderFns } from "./LaborTeamList.vue?vue&type=template&id=5ed3aed0&scoped=true"
import script from "./LaborTeamList.vue?vue&type=script&lang=js"
export * from "./LaborTeamList.vue?vue&type=script&lang=js"
import style0 from "./LaborTeamList.vue?vue&type=style&index=0&id=5ed3aed0&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"
import style1 from "./LaborTeamList.vue?vue&type=style&index=1&id=5ed3aed0&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed3aed0",
  null
  
)

export default component.exports